import { Component, OnInit, AfterContentChecked, Input, Output, EventEmitter } from '@angular/core';
import { IMyDpOptions, IMyDateModel, IMyDayLabels, IMyMonthLabels, IMyDate } from 'mydatepicker';

import { Patient } from '../patient';

@Component({
  selector: 'mc-patient-form',
  templateUrl: './patient-form.component.html',
  styleUrls: ['./patient-form.component.scss']
})
export class PatientFormComponent implements OnInit, AfterContentChecked {

  @Input() patient: Patient;
  @Output() canceled: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() saved: EventEmitter<Patient> = new EventEmitter<Patient>();
  public dob: Object;
  private today: Date  = new Date();
  public myDpOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    alignSelectorRight: true,
    satHighlight: true,
    dayLabels: <IMyDayLabels>{ su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
    monthLabels: <IMyMonthLabels>{
      1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez'
    },
    disableSince: {
      year: this.today.getFullYear(),
      month: this.today.getMonth() + 1,
      day: this.today.getDate() + 1
    }
  };
  private CELLPHONE: string = '(00)00000-0000';
  private LANDLINE: string = '(00)0000-0000'; 
  public homephoneMask = this.CELLPHONE;
  public cellphoneMask = this.CELLPHONE;
  
  constructor() { }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    if (this.patient) {
      if (this.patient.homephone) this.onHomephoneChanged(this.patient.homephone);
      if (this.patient.cellphone) this.onCellphoneChanged(this.patient.cellphone);
      
      if (!this.dob) {
        let a = this.patient.dob.toString().split("-");
        this.dob = {
          jsdate: new Date(
            parseInt(a[0]),
            parseInt(a[1]) - 1,
            parseInt(a[2])
          )
        };
      }
    }
  }

  onDobChanged(event: IMyDateModel) {
    this.patient.dob = event.jsdate;
    this.dob = { jsdate: event.jsdate };
  }

  onHomephoneChanged(phone: string): void {
    if (!phone || phone.length < 3) { return; }

    if (phone.charAt(2) == '9') {
      this.homephoneMask = this.CELLPHONE;

    } else {
      this.homephoneMask = this.LANDLINE;
    }
  }

  onCellphoneChanged(phone: string): void {
    if (!phone || phone.length < 3) { return; }

    if (phone.charAt(2) == '9') {
      this.cellphoneMask = this.CELLPHONE;

    } else {
      this.cellphoneMask = this.LANDLINE;
    }
  }

  save(): void {
    this.saved.emit(this.patient);
  }

  cancel(): void {
    this.canceled.emit(true);
  }
}
